import { useEffect, useState } from "react";
import api, { formatMoney } from "@/lib/api";
import { PageHeader, Panel, StatCard } from "@/components/Bits";
import { Buildings, MapPin, Users, CurrencyCircleDollar } from "@phosphor-icons/react";

export default function Branches() {
  const [branches, setBranches] = useState([]);
  const [perf, setPerf] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/branches"), api.get("/analytics/branch-performance")])
      .then(([b, p]) => { setBranches(b.data); setPerf(p.data); });
  }, []);

  const map = Object.fromEntries(perf.map(p => [p.branch_id, p]));

  return (
    <div>
      <PageHeader eyebrow="Network" title="All centres" subtitle="Local autonomy, global oversight." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {branches.map(b => {
          const p = map[b.branch_id] || {};
          return (
            <div key={b.branch_id} className="bg-white rounded-3xl border border-border p-6 hover:shadow-hoverlift transition" data-testid={`branch-${b.branch_id}`}>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl" style={{ background: b.brand_color + "20", color: b.brand_color }}>🏫</div>
                <div className="flex-1">
                  <div className="font-heading text-lg font-bold">{b.name}</div>
                  <div className="text-xs text-ink-soft flex items-center gap-1 mt-0.5"><MapPin size={12} /> {b.city}, {b.country}</div>
                </div>
              </div>
              <div className="mt-4 text-sm text-ink-soft">{b.address}</div>
              <div className="mt-2 text-sm">{b.phone}</div>
              <div className="mt-2 text-sm">{b.email}</div>
              <div className="grid grid-cols-3 gap-2 mt-5 text-center">
                <div className="bg-paper-alt rounded-xl p-2"><div className="font-heading font-bold text-lg">{p.students || 0}</div><div className="text-xs text-ink-soft">Students</div></div>
                <div className="bg-paper-alt rounded-xl p-2"><div className="font-heading font-bold text-lg">{b.capacity}</div><div className="text-xs text-ink-soft">Capacity</div></div>
                <div className="bg-paper-alt rounded-xl p-2"><div className="font-heading font-bold text-lg">{b.currency}</div><div className="text-xs text-ink-soft">Currency</div></div>
              </div>
              <div className="mt-4 text-xs">
                <div className="flex justify-between"><span className="text-ink-soft">Fees collected</span><span className="font-semibold">{formatMoney(p.fees_collected, b.currency)}</span></div>
                <div className="flex justify-between mt-1"><span className="text-ink-soft">Conversion</span><span className="font-semibold">{p.conversion_rate || 0}%</span></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
